module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-ii/header--solo-538c1523b5ab1858db1330ca56ec959a.png";